import axios from "axios";
import { Client } from "client-sdk/src";
import handleError from "../utils/handleError";
import { GetTicketRequestBuilder } from "client-sdk/src/helpical/categories"

const token = localStorage.getItem("token");

export async function getTicketById(id: any) {
  try {
    const getTicket = new GetTicketRequestBuilder()
    .id(id)
      .build();
    const client = new Client(token as string);
    const response = client.execute(
     getTicket,
    );
    return response;
  } catch (error) {
    return handleError(error);
  }
}
export default getTicketById;
